import styles from "./LogoContainer.module.scss";
import * as React from "react";
import classnames from "classnames";

import Logo from "../Logo";

type Props = {
    classes?: string[];
};

export const LogoContainer = (props: Props) => {
  return (
    <div className={classnames(styles["logo-container"], props.classes)}>
      <Logo classes={[styles.logo]} />
    </div>
  )
}

export default LogoContainer
